export default __webpack_public_path__ + "static/media/picture1.114abbce.png";